module.exports = __webpack_public_path__ + "static/media/nobuilding.0b82bc46.svg";